<template>
    <div
        class="flex items-center shrink-0 gap-2 py-2 px-4 rounded-full border-2 "
        style="background: hsla(0, 0%, 100%, 0.1); cursor: pointer;"
        :class="{
            'border-[#924AFF]': isActive,
            'border-transparent': !isActive
        }"
        @click="$emit('click', value)"
    >
        <img
            :src="icon"
            class="mx-auto p-0 m-0"
            style="width: 2rem"
            :alt="label"
        />
        <span
            class="text-[13px] whitespace-nowrap"
            :class="{ 'text-white': isActive }"
        >
            {{ label }}
        </span>
    </div>
</template>

<script>
export default {
    name: 'TabItem',
    props: {
        value: { type: String, required: true },
        label: { type: String, required: true },
        icon: { type: String, required: true },
        isActive: { type: Boolean, default: false },
    },
};
</script>

<style scoped></style>
